import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { IMajorProgramResponse } from './../../major_explorer_interface';
import { MajorCredential } from './../builders/major_credential_builder';
import { MajorProgram } from './../builders/major_programs_builder';
import { MajorProgramModel } from './../models/major_program_model';

angular
  .module('major-explorer-data')
  .factory(
    'loadStudentCurrentMajorCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      ngMajorCurrentMajorsDatastore: IDatasource<MajorProgram>,
      ngMajorCredentialDatastore: IDatasource<MajorCredential>,
      ngMajorProgramModel: MajorProgramModel
    ) => {
      return defineCommand('loadStudentCurrentMajorCommand', (deferred: ng.IDeferred<any>) => {
        $http
          .get('programpicker/program/current/')
          .then(({ data }: { data: IMajorProgramResponse }) => {
            ngMajorProgramModel.write(data);
            ngMajorCurrentMajorsDatastore.clear().write(data.program);
            ngMajorCredentialDatastore.write(data.program_credential);
            deferred.resolve(data);
            ORM.run();
          })
          .catch(({ error }) => {
            deferred.reject(error);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_student_current_major_command.ts